import { toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7755cb7c")

_pushScopeId("data-v-7755cb7c")
const _hoisted_1 = { class: "dialog-overlay" }
const _hoisted_2 = { class: "dialog-box" }
const _hoisted_3 = { class: "dialog-message-box" }
const _hoisted_4 = { class: "dialog-message-box-text" }
const _hoisted_5 = { class: "dialog-button-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_Transition, { name: "dialog" }, {
      default: _withId(() => [
        _withDirectives(_createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("span", _hoisted_4, _toDisplayString(_ctx.message), 1)
            ]),
            _createVNode("div", {
              class: "dialog-button-box",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeClicked(...args)))
            }, [
              _createVNode("div", _hoisted_5, _toDisplayString(_ctx.okText), 1)
            ])
          ])
        ], 512), [
          [_vShow, _ctx.showDialog]
        ])
      ]),
      _: 1
    })
  ]))
})